module.exports = __webpack_public_path__ + "wayne-segar05-cropped.jpg?904a1c808a6ff0d2ec8f5323b53c381e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headshots/wayne-segar05-cropped.jpg
// module id = 38
// module chunks = 0